import DataGrid, { Column, ColumnFixing, FilterRow, HeaderFilter, Paging, Scrolling } from "devextreme-react/data-grid";
import "devextreme/dist/css/dx.softblue.css";
import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { Routes } from "../../../../AppRoutes";
import { setRefreshFolder, setSelectedFolder } from "../../../../actions/documentAction";
import { Box } from "../../../../components/box";
import FontFa from "../../../../components/fontFa/fontFa";
import { CreateNotification } from "../../../../components/notifier";
import { SharePointLinkType, SharePointScope } from "../../../../constants/sharePointConstant";
import { documentStatus, userAction } from "../../../../constants/statusConstants";
import { getDiffDay } from "../../../../helper/dateTimeHelper";
import { openUrl, showDocumentPerrmissionAccessDenied } from "../../../../helper/util";
import WarningDeleteModal from "../../../../modals/warning-delete-modal";
import { DocumentService } from "../../../../services/document/document.service";
import { FileService } from "../../../../services/file/file.service";
import { SET_UNAUTHORIZED_ERROR } from "../../../../services/main/main.reducer";
import { PermissionService } from "../../../../services/permission/permission.service";
import { TeamsService } from "../../../../services/teams/teams.service";
import { store, useSelector } from "../../../../store/store";
import AddFileModal from "../../modal/add-file-modal";
import AddFolderModal from "../../modal/add-folder-modal";
import { getTitleForDocument } from "../../util";
import { DocumentDataGridItem } from "./document-datagrid-item";
import type { FolderListRef } from "./document-list-trial2";
import { DepartmentList } from "./permission-department/department-list";
import { useSearchParams } from "../../../../hook/use-search-params";
import { DocumentLinkService } from "../../../../services/document/document-link.service";
import { useDocumentType } from "../../hooks/documents/use-document-type";
import { useDocumentDepartment } from "../../hooks/documents/use-document-department";
import { useDocumentTags } from "../../../setting/document/document-tags/hooks/useDocumentTags";
import { Select, Button as AntButton, Input, Spin, message, Space } from "antd";
import { useLocation } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import UpdateFolderModal from "../../modal/update-folder-modal";
import { usePublishFolder } from "../../hooks/published-documents/use-publish-document-folder";
import moment from "moment";
import { produce } from "immer";
import DocumentOrderProvider from "../../contexts/DocumentOrderContext";
import { useUpdateDocument } from "../../hooks/documents/use-update-document";
// import { getEnv } from "../../../../AppConfigs";
// const listId = getEnv("REACT_APP_PUBLIC_FOLDER_AND_FILE_SP_LIST_ID");
import { PublishMultiplePublishFileModal } from "../../modal/publish-multiple-file/publish-multiple-publish-file-modal";
import { orderBy } from "lodash";
import { useUser } from "../../../../hook";
import PublicDocumentListDraggable from "./public-document-list-draggable";
import { SortAscendingOutlined } from "@ant-design/icons";
import { useMineInfo } from "../../../../contexts/mine-info-context";
import PERMISSIONS from "../../../../constants/permissions";
import MESSAGES from "../../../../constants/messages";

const isDocumentExpired = (effectiveTo: string) => {
  const today = new Date();
  return getDiffDay(effectiveTo, today.toDateString()) >= 0;
};

const anyElementMatches = (arr1: string[], arr2: string[]): boolean => {
  return arr1.some((item1) => arr2.includes(item1));
};

export const PublishDocumentList = memo((props: any) => {
  const {
    statusQuery,
    filterExpired,
    menuTitle,
    listId,
    isShowCheckColumn,
    isShowAction,
    onSelectedDocument,
    isDepartment,
    onSelectedFolder,
  } = props;

  const user = useSelector((state) => state.user);
  const mainState = useSelector((state) => state.main);
  const email = user?.current?.username;
  const dispatch = useDispatch();
  const [openPermissionModal, setOpenPermissionModal] = useState(false);
  const [openAddFolderModal, setOpenAddFolderModal] = useState(false);
  const [openUpdateFolderModal, setOpenUpdateFolderModal] = useState(false);
  const [openAddFileModal, setOpenAddFileModal] = useState(false);
  const [showDeletedConfirm, setShowDeletedConfirm] = useState(false);
  const [currentDocument, setCurrentDocument] = useState<any>();
  const [currentDocumentPermissionProcess, setCurrentDocumentPermissionProcess] = useState<any[]>();
  const [documentData, setDocumentData] = useState<any>([]);
  const filterScopes = statusQuery === documentStatus.publish.value ? [SharePointScope.users] : [SharePointScope.users];
  const filterTypes =
    statusQuery === documentStatus.publish.value
      ? [SharePointLinkType.view, SharePointLinkType.edit, SharePointLinkType.blocksDownload]
      : [SharePointLinkType.view, SharePointLinkType.edit];

  const [deletedItem, setDeletedItem] = useState<any>();
  const [deletedTitle, setDeletedTitle] = useState<any>();
  const [deletedMessge, setDeletedMessage] = useState<any>();
  // const [documentRequestId, setDocumentRequestId] = useState<any>();
  const history = useHistory();
  const [show, set] = useState(true);
  const [searchInputValue, setSearchInputValue] = useState("");
  // const inputSearchRef = useRef<HTMLInputElement | null>(null);
  const folderListRef = useRef<FolderListRef>(null);
  const { searchParams, replaceSearchParams } = useSearchParams();
  const isSystem = !!searchParams.get("system");
  const { data: documentType } = useDocumentType();
  const { data: documentDepartment } = useDocumentDepartment();
  const { dataOptions } = useDocumentTags();
  const [selectedTags, setSelectedTags] = useState<string[]>([]);
  const tags = searchParams.get("tags");
  const { pathname } = useLocation();
  const folderId = searchParams.get("folderId");
  const isDeleteFolder = !!searchParams.get("isDeleteFolder");
  const { data: selectedFolderInfo } = usePublishFolder();
  const queryClient = useQueryClient();
  const [isShowDataGrid, setIsShowDataGrid] = useState(false);
  const { userAdmin } = useUser();
  const sortByName = searchParams.get("sort") === "abc";
  const [departmentId, setDepartmentId] = useState<number>();
  const currentUserEmail = user?.current?.username?.toLowerCase();

  const { checkPermission } = useMineInfo();

  const { mutate: updateDocument, isLoading: isUpdateDocumentLoading } = useUpdateDocument();

  const onChangeOrder = (info: { order: string; data: any }) => {
    const { order, data } = info;
    updateDocument(
      { docId: data.listItemId, fields: { docOrder: order }, listId },
      {
        onSuccess() {
          message.success("Thay đổi vị trí thành công");
          setDocumentData(
            produce((draft: any) => {
              const document = draft.find((doc: any) => doc.listItemId === data.listItemId);
              document.docOrder = Number(order);
            }),
          );
        },
        onError() {
          message.error("Thay đổi vị trí thất bại");
        },
      },
    );
  };

  const toggleAddFolder = () => {
    setOpenAddFolderModal(!openAddFolderModal);
    searchParams.delete("addRoot");
    replaceSearchParams(searchParams);
  };

  const toggleAddParentFolder = () => {
    setOpenAddFolderModal(!openAddFolderModal);
    searchParams.set("addRoot", "true");
    replaceSearchParams(searchParams);
  };

  const toggleRenameFolder = () => {
    setOpenUpdateFolderModal(!openUpdateFolderModal);
  };

  const goToTeams = async (item: any) => {
    try {
      let itemId = item?.listItemId;
      if (statusQuery === documentStatus.publish.value) itemId = item?.docWorkingId;

      var document = await DocumentService.getDocumentInfo(itemId);
      if (document && document.chatGroupId && document.chatGroupName) {
        var url = TeamsService.getRedirectLinkFromFileChatGroup(document.chatGroupId, document.chatGroupName);
        window.open(url, "_blank");
      }
    } catch (error: any) {
      CreateNotification({ title: "Không thể mở teams", body: error.message, icon: "/icons/error.png" });
      console.log(error);
    }
  };

  const checkWritePermissionOnDocument = useCallback(
    async (id: string, currentDocumentPermissionProcess: any[] = []) => {
      try {
        var hasWritePermission = await PermissionService.checkWritePermission(
          user,
          id,
          listId,
          isDeleteFolder,
          user.isMasterUser,
        );
        if (currentDocumentPermissionProcess && currentDocumentPermissionProcess?.length > 0) {
          const userEmail =
            user?.current?.username?.toLowerCase() === "culi1@viags.vn"
              ? "culi1@viagsvn.onmicrosoft.com"
              : user?.current?.username?.toLowerCase();
          if (
            currentDocumentPermissionProcess.findIndex(
              (e) => e.users[0].email === userEmail && e.roles[0] === "write",
            ) > -1
          )
            hasWritePermission = true;
        }
        if (!hasWritePermission) {
          CreateNotification({
            title: "Không thể chỉnh sửa",
            body: `Anh/Chị không có quyền chỉnh sửa file này`,
            icon: "/icons/error.png",
          });
          return false;
        }
      } catch (error: any) {
        CreateNotification({ title: "Không thể truy cập", body: error.message, icon: "/icons/error.png" });
        console.log(error);
        return false;
      }

      return true;
    },
    [isDeleteFolder, listId, user],
  );

  const handleDeleteConfirmDialog = async (item: any) => {
    if (!checkPermission(PERMISSIONS.DELETE_OR_ARCHIVE_DOCUMENT)) return message.error(MESSAGES.NOT_PERMISSION);

    if ((await checkWritePermissionOnDocument(item.id)) === false) return;

    setDeletedTitle("Xoá tài liệu");
    setDeletedMessage(`Bạn có muốn xóa tài liệu '${item?.Title || item?.nameWithoutExt}' không ?`);

    setDeletedItem(item);
    setShowDeletedConfirm(true);
  };

  const handleCloseDeletedConfirm = () => {
    setShowDeletedConfirm(!showDeletedConfirm);
  };

  const handleDeletedConfirm = () => {
    if (deletedItem) processDeletedItem(deletedItem);
  };

  const processDeletedItem = (item: any) => {
    FileService.deletedFile(item.id, listId).then(
      () => {
        const body = "Xoá thành công";
        queryClient.invalidateQueries({ queryKey: ["folders"] });
        searchParams.delete("folderId");
        replaceSearchParams(searchParams);
        CreateNotification({ title: "Thành công", body: body, icon: "/icons/success.png" });
      },
      (error) => {
        CreateNotification({ title: "Thất bại", body: `Xoá thất bại`, icon: "/icons/error.png" });
        console.log(error);
      },
    );
  };

  const openDocumentUrl = (item: any) => {
    if (item?.IsCustomEditor) {
      goToDetail(item, "file");
      return;
    }

    openUrl(item?.url);
  };

  const goToDetail = (item: any, action: string = "", mode: string = "", templateId: any = null) => {
    let filters = [];

    let itemId = item?.listItemId;

    if (statusQuery === documentStatus.publish.value || pathname === "/version-document-content") {
      itemId = item?.docWorkingId;
      // filters.push(`action=info`);
    }

    if (!itemId) {
      itemId = 0;
    }

    if (action !== null && action !== "") {
      filters.push(`action=${action}`);
    }

    if (statusQuery === documentStatus.publish.value) {
      filters.push(`status=${statusQuery}`);
    }

    if (templateId) {
      filters.push(`templateId=${templateId}`);
    }

    if (mode === userAction.new && folderId) {
      filters.push(`folderId=${folderId}`);
    }

    if (mode !== "") {
      filters.push(`mode=${mode}`);
    }

    if (item?.id) {
      filters.push(`fileId=${item.id}`);
    }

    if (statusQuery === documentStatus.needProcess.value) {
      filters.push(`action=link`);
    }

    let filterQuery = "";
    if (filters.length > 0) {
      filterQuery = `?${filters.join("&")}`;
    }
    history.push(Routes.documentDetail.path.replace(":id", `${itemId}${filterQuery}`));
  };

  const goToDetailProcess = (item: any) => {
    goToDetail(item, userAction.process);
  };

  const goToDetailEdit = async (item: any) => {
    if (!(await checkWritePermissionOnDocument(item))) return;

    goToDetail(item, "", userAction.edit);
  };

  const goToPermission = useCallback(
    async (item: any) => {
      try {
        var result = await PermissionService.getDocumentPermissons(item.id, listId, item.isFolder);
        if (!(await checkWritePermissionOnDocument(item, result.data))) return;
        if (result.count > 0) {
          setCurrentDocumentPermissionProcess(result.data);
        }
        setCurrentDocument(item);
        try {
          const itemInfo: any = await DocumentService.getPublicDocumentInfoFromWorkingDocument(
            item.docWorkingId,
            listId,
          );

          if (itemInfo) {
            const fileAssignedTo = itemInfo.fileAssignedTo ? JSON.parse(itemInfo.fileAssignedTo) : [];

            const editUser = fileAssignedTo.find(
              (s: { email: string; isEdit: boolean }) => s.email.toLowerCase() === currentUserEmail && s.isEdit,
            );

            const departmentId = userAdmin && userAdmin.id ? null : editUser?.department;

            if (setDepartmentId) setDepartmentId(departmentId);
          }
        } catch {}
        setOpenPermissionModal(!openPermissionModal);
      } catch (error: any) {
        CreateNotification({ title: "Không thể truy cập phân quyền", body: error.message, icon: "/icons/error.png" });
        console.log(error);
      }
    },
    [checkWritePermissionOnDocument, currentUserEmail, listId, openPermissionModal, userAdmin],
  );

  const toggleAddFile = () => {
    setOpenAddFileModal(!openAddFileModal);
  };

  const getDocuments = useCallback(async () => {
    try {
      const paramListId = listId;
      let results: any = { data: [], count: 0 };
      if (folderId) {
        results = await FileService.getChild(folderId, paramListId, true);

        // const driveItemChildren = await FileService.getChild(folderId, paramListId);
        // const filteredFolders = driveItemChildren.data.filter((item: { isFolder: boolean }) => item?.isFolder);
        // const filteredFiles = driveItemChildren.data.filter((item: { isFolder: boolean }) => !item?.isFolder);
      } else {
        // results = await FileService.getRootFolder(paramListId, true);
        // console.log("results", results);
      }

      const docTags = tags?.split(",");
      if (!docTags) return results;
      results.data = results?.data?.filter((e: any) => e.Tags?.length > 0 && anyElementMatches(e.Tags, docTags));

      return results;
    } catch (error: any) {
      if (error.status === 403) {
        showDocumentPerrmissionAccessDenied();
      } else if (error.status === 401) {
        store.dispatch({
          type: SET_UNAUTHORIZED_ERROR,
          status: true,
        });
      }
      setDocumentData([]);
      return { data: [], count: 0 };
    }
  }, [folderId, listId, tags]);

  const getDocumentLinkExpired = useCallback(
    async (listItemId: string) => {
      if (statusQuery || !folderId || pathname.includes("statistic")) return false;
      const res = await DocumentLinkService.getDocumentLinkInfos(listItemId);
      const dataArr = !res?.data ? [] : [...res.data];
      const isHasExpired = dataArr.findIndex((e) => isDocumentExpired(e.docLinkExpiredDate)) > -1;
      return isHasExpired;
    },
    [folderId, pathname, statusQuery],
  );

  const getDocumentData = useCallback(() => {
    getDocuments().then((results) => {
      if (!results) return;

      results.data?.forEach((obj1: any) => {
        const docTypeObject = documentType?.find((obj2: any) => obj2.value === obj1.docTypeId);
        const docPublicDepartmentObject = documentDepartment?.find(
          (obj2: any) => obj2.value === obj1.docPublicDepartmentLookupId,
        );
        if (docTypeObject) obj1.docType = docTypeObject.label;
        if (docPublicDepartmentObject) obj1.docPublicDepartment = docPublicDepartmentObject.label;
      });

      const filteredDocumentData = results.data.filter((e: any) => !moment(e?.expiredDate).isSameOrBefore(moment()));
      setDocumentData(filteredDocumentData);

      if (isDepartment) onSelectedFolder(filteredDocumentData);
    });
  }, [documentType, getDocuments, isDepartment, onSelectedFolder, documentDepartment]);

  const onImportFileCompleted = (files: any[]) => {
    if (files.length > 1) dispatch(setRefreshFolder(true));
    // callRefreshData();
    history.push(
      Routes.documentDetail.path.replace(
        ":id",
        files[0].docId + `?&action=${userAction.info}&mode=${userAction.edit}&fileId=${files[0].fileId}`,
      ),
    );
  };

  const handleHidePermissionModal = () => {
    setOpenPermissionModal(!openPermissionModal);
  };

  const showFolder = () => {
    return !statusQuery || (statusQuery === documentStatus.publish.value && ["false", ""].includes(filterExpired));
  };

  const validFile = (file: any) => {
    return documentData.find((cf: any) => cf.name === file.name) != null ? MESSAGES.DUPLICATE_DOCUMENT : "";
  };

  useEffect(() => {
    if (folderId) getDocumentData();
  }, [folderId, getDocumentData]);

  const handleSearchInputChange = async (e: string) => {
    searchParams.set("folderId", "");
    replaceSearchParams(searchParams);
    const searchInputValue = e?.trim();
    setSearchInputValue(searchInputValue);

    try {
      if (searchInputValue) {
        const res = await DocumentService.searchPublicDocuments(searchInputValue);
        if (res.length === 0) return;
        const result = await DocumentService.getPublishDocumentByListId(res);
        if (result.count !== 0) {
          setIsShowDataGrid(true);
          const filteredData = result.data.filter((e: any) => !moment(e?.effectiveTo).isSameOrBefore(moment()));

          setDocumentData(filteredData);
        }
      } else {
        if (folderId) {
          getDocumentData();
        } else {
          setIsShowDataGrid(false);
        }
      }
    } catch (error) {
      // Handle the error here
      console.error("An error occurred:", error);
    }
  };

  const contentGridTitle = searchInputValue
    ? `Danh sách tìm kiếm: ${searchInputValue}`
    : selectedFolderInfo?.data?.name || menuTitle;

  const handleFilterClick = () => {
    if (selectedTags.length === 0) {
      searchParams.delete("tags");
      replaceSearchParams(searchParams);
      return;
    }
    searchParams.set("tags", selectedTags.toString());
    replaceSearchParams(searchParams);
  };

  const sortedDocumentData = useMemo(() => {
    return orderBy(
      documentData,
      [
        (item) => (item?.docOrder === undefined ? Infinity : item.docOrder),
        (item) => new Date(item.LastModifiedDateTime).getTime(),
      ],
      ["asc", "desc"],
    );
  }, [documentData]);

  const toggleSort = () => {
    const currentSort = searchParams.get("sort");

    if (currentSort === "abc") {
      searchParams.delete("sort");
    } else {
      searchParams.set("sort", "abc");
    }

    replaceSearchParams(searchParams);
  };

  const loading = isUpdateDocumentLoading;

  return (
    <>
      <Row>
        <Col sm={4} md={4} hidden={!showFolder()}>
          <Box
            title="Danh sách thư mục"
            onTitleClick={() => {
              set(!show);
              folderListRef.current?.resetParams();
              dispatch(setSelectedFolder(null));
            }}
            titleRight={
              <Space>
                <Button
                  disabled={mainState.isForbidden}
                  title={"Tạo thư mục"}
                  onClick={toggleAddParentFolder}
                  className="mx-2 mt-2"
                  variant="outline-warning"
                  hidden={isShowCheckColumn || statusQuery}
                >
                  <FontFa name="faFolderPlus" size={"lg"} />
                </Button>
                <AntButton onClick={toggleSort} icon={<SortAscendingOutlined rev={""} />} style={{ margin: "8px" }}>
                  {sortByName ? "Default" : "A → Z"}
                </AntButton>
              </Space>
            }
            className={"menu-item mb-2"}
          >
            <Input.Search placeholder="Nhập tên tài liệu cần tìm" onSearch={handleSearchInputChange} enterButton />
            <div style={{ marginTop: 8, height: "665px", overflow: "auto" }}>
              <PublicDocumentListDraggable />
            </div>
          </Box>
        </Col>
        {folderId || !showFolder() || isShowDataGrid ? (
          <Col sm={8} md={8}>
            <div className={"Content__grid-hide"}>
              <Box title={contentGridTitle}>
                <div className="d-flex justify-content-between">
                  <div className="d-flex column">
                    <Select
                      options={dataOptions}
                      placeholder="Vui lòng chọn chủ đề"
                      mode="multiple"
                      size="middle"
                      value={selectedTags}
                      optionFilterProp="label"
                      style={{ width: "400px" }}
                      onChange={(value) => setSelectedTags(value)}
                      allowClear
                    />
                    <AntButton
                      style={{ paddingTop: "-20px", paddingBottom: "-10px", marginLeft: "10px" }}
                      onClick={() => handleFilterClick()}
                      type="primary"
                      size="middle"
                    >
                      Lọc dữ liệu
                    </AntButton>
                  </div>
                  <div className="d-flex column">
                    {isShowAction && userAdmin?.id && (
                      <PublishMultiplePublishFileModal
                        documentData={documentData ?? []}
                        getDocumentData={getDocumentData}
                        isPublish={true}
                      />
                    )}
                    <p className="font-weight-bold align-items-baseline">
                      Tổng cộng:{" "}
                      <span className="px-1 text-primary" style={{ fontSize: "22px" }}>
                        {sortedDocumentData?.length}
                      </span>{" "}
                      tài liệu
                    </p>
                  </div>
                </div>
                <div className="w-full overflow-auto">
                  <DocumentOrderProvider onChangeOrder={onChangeOrder}>
                    <Spin spinning={loading}>
                      <DataGrid
                        id="grid__title-container"
                        dataSource={sortedDocumentData}
                        noDataText="Không tìm thấy tài liệu"
                        showBorders={true}
                        disabled={isDepartment}
                        showColumnLines={true}
                        rowAlternationEnabled={true}
                        wordWrapEnabled={true}
                        width={2500}
                        loadPanel={{ enabled: true }}
                        dataRowRender={(datRow) => (
                          <DocumentDataGridItem
                            document={datRow.data}
                            statusView={statusQuery}
                            isShowAction={isShowAction}
                            isShowCheckColumn={isShowCheckColumn}
                            openDocumentUrl={openDocumentUrl}
                            goToDetail={goToDetail}
                            goToDetailEdit={goToDetailEdit}
                            searchInputValue={searchInputValue}
                            goToPermission={goToPermission}
                            goToDetailProcess={goToDetailProcess}
                            goToTeams={goToTeams}
                            listId={listId}
                            deleteConfirmDialog={handleDeleteConfirmDialog}
                            onSelectedDocument={onSelectedDocument}
                            wordWrapEnabled={true}
                            filterExpired={filterExpired}
                            currentEmail={email}
                            getDocumentLinkExpired={getDocumentLinkExpired}
                          />
                        )}
                      >
                        <Scrolling mode="standard" />
                        <ColumnFixing enabled={true} />
                        <FilterRow visible={true} applyFilter={true} />
                        <HeaderFilter visible={true} />
                        <Paging defaultPageSize={10} />
                        {isShowCheckColumn && <Column width={40} fixed={true} fixedPosition="left" />}
                        {!isShowCheckColumn && <Column name="actions" fixed={true} width={150} alignment="center" />}
                        <Column
                          fixed={true}
                          fixedPosition="left"
                          dataField="Title"
                          caption="Tên tài liệu"
                          minWidth={400}
                          allowHeaderFiltering={false}
                        />
                        <Column
                          dataField="docCode"
                          caption="Mã tài liệu"
                          allowHeaderFiltering={false}
                          alignment="left"
                        />
                        <Column dataField="docType" caption="Loại tài liệu" />
                        <Column dataField="docStatus" caption="Tình trạng" />
                        <Column
                          dataField="effectiveDate"
                          dataType="date"
                          selectedFilterOperation="between"
                          caption="Ngày hiệu lực"
                          width={150}
                        />
                        <Column
                          dataField="docPublishViewVersion"
                          caption="Lần ban hành"
                          dataType="number"
                          allowHeaderFiltering={false}
                          width={120}
                        />
                        <Column
                          dataField="docEditionVersion"
                          caption="Lần sửa đổi"
                          dataType="number"
                          allowHeaderFiltering={false}
                          width={100}
                        />
                        <Column
                          dataField="createdDateTime"
                          caption="Thời gian khởi tạo"
                          dataType="date"
                          selectedFilterOperation="between"
                          allowHeaderFiltering={false}
                        />
                        <Column dataField="createdUser.displayName" caption="Người khởi tạo" dataType="string" />
                        <Column
                          dataField="lastModifiedDateTime"
                          caption="Thời gian cập nhật"
                          dataType="date"
                          selectedFilterOperation="between"
                          allowHeaderFiltering={false}
                        />
                        <Column dataField="modifiedUser.displayName" caption="Người cập nhật" dataType="string" />
                        <Column dataField="tags" caption="Chủ đề" allowHeaderFiltering={false} width={240}>
                          <HeaderFilter />
                        </Column>
                        <Column caption="Vị trí" dataField="id" dataType="string" width={100} />
                      </DataGrid>
                    </Spin>
                  </DocumentOrderProvider>
                </div>
              </Box>
            </div>
          </Col>
        ) : isSystem ? (
          <Col sm={8} md={9}>
            <img src="assets/images/chinhsachATCL.jpg" alt="" height="60%" />
          </Col>
        ) : (
          <Col sm={{ span: 5, offset: 3 }} md={{ span: 4, offset: 3 }}>
            <img src="assets/images/quytrinhtieuchuan.jpg" alt="" />
          </Col>
        )}
      </Row>

      <DepartmentList
        id={currentDocument?.id}
        title={getTitleForDocument(currentDocument)}
        listId={listId}
        isDocumentLibrary={true}
        linkProcess={currentDocumentPermissionProcess}
        filterScopes={filterScopes}
        filterTypes={filterTypes}
        isOpen={openPermissionModal}
        onClose={handleHidePermissionModal}
        document={currentDocument}
        isPublishStatus={statusQuery}
        isAddMore={true}
        departmentId={departmentId}
      />
      <AddFolderModal onClose={toggleAddFolder} isOpen={openAddFolderModal} />
      <UpdateFolderModal
        onClose={toggleRenameFolder}
        isOpen={openUpdateFolderModal}
        oldFolderName={selectedFolderInfo?.data?.name || ""}
        folderId={selectedFolderInfo?.data?.listItem?.id}
      />
      <AddFileModal
        onClose={toggleAddFile}
        onAddFileCompleted={onImportFileCompleted}
        isOpen={openAddFileModal}
        validFile={validFile}
      />
      <WarningDeleteModal
        data={deletedItem}
        title={deletedTitle}
        message={deletedMessge}
        isOpen={showDeletedConfirm}
        onDelete={handleDeletedConfirm}
        onClose={handleCloseDeletedConfirm}
      />
    </>
  );
});
